module.exports = __webpack_public_path__ + "img/equipmentImg.8d099c94.jpg";